import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState
} from "react";
import { shareIcons } from "../../utils/shareIcons";
import ShareIcon from "../../images/icons/share-icon.inline.svg";

// eslint-disable-next-line react/display-name
const ShareBtn = forwardRef(({ url, fillLight, fillDark }, ref) => {
  const [openShareWith, setOpenShareWith] = useState(false);
  const [shareUrl, setShareUrl] = useState("");

  const shareWithMediaArr = shareIcons(shareUrl);

  useImperativeHandle(ref, () => ({
    handleClick() {
      setOpenShareWith(!openShareWith);
    }
  }));

  useEffect(() => {
    setShareUrl(encodeURI(url ?? "#"));
  }, [url]);

  return (
    <div className="relative flex items-center justify-right">
      <ShareIcon
        onClick={() => setOpenShareWith(!openShareWith)}
        className={"fill-black-lighter dark:fill-gray-generic"}
      />
      {openShareWith && (
        <div className="absolute -top-[13px] -left-[14px] z-10">
          <ul
            className="flex flex-col gap-2 border border-gray-lighter rounded-xxxxl p-3 dark:bg-gray-dark bg-generic-bg"
            style={{
              boxShadow: "0px 4px 40px rgba(0, 0, 0, 0.25)"
            }}
          >
            <li>
              <ShareIcon
                onClick={() => setOpenShareWith(!openShareWith)}
                className={
                  "fill-black-lighter dark:fill-gray-generic hover:dark:fill-white hover:fill-black-lighter opacity-60 hover:opacity-100 w-5 h-5"
                }
              />
            </li>
            {shareWithMediaArr &&
              shareWithMediaArr.length > 0 &&
              shareWithMediaArr.map((media, idx) => {
                return <li key={idx}>{media.node}</li>;
              })}
          </ul>
        </div>
      )}
    </div>
  );
});

export default ShareBtn;